const initialState = {
    isUpdatingNote: false,
    note: {},
    isReadingNote: false,
    noteBeingUpdated: null,
    noteBeingDeleted: null
}

export default initialState;
